import { render, staticRenderFns } from "./AuditCRUDDialog.vue?vue&type=template&id=b2b232a6&scoped=true&"
import script from "./AuditCRUDDialog.vue?vue&type=script&lang=js&"
export * from "./AuditCRUDDialog.vue?vue&type=script&lang=js&"
import style0 from "./AuditCRUDDialog.vue?vue&type=style&index=0&id=b2b232a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b232a6",
  null
  
)

export default component.exports